import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

const TONES = {
  success: 'bg-success bg-opacity-10 text-success',
  warning: 'bg-orange-500 bg-opacity-10 text-orange-500',
  danger: 'bg-danger bg-opacity-10 text-danger',
  neutral: 'bg-body-text bg-opacity-10 text-body-text'
}

const SOLID_TONES = {
  success: 'bg-success text-white',
  warning: 'bg-orange-500 text-white',
  danger: 'bg-danger text-white',
  neutral: 'bg-body-text text-white'
}

const SOLID_ICONS = {
  success: UIcons.UilCheckCircle,
  warning: UIcons.UilClockThree,
  danger: UIcons.UilTimesCircle,
  neutral: UIcons.UilPause
}

export const STATUS_TONE = {
  active: 'success',
  running: 'success',
  success: 'success',
  pending: 'warning',
  upcoming: 'warning',
  scheduled: 'warning',
  paused: 'neutral',
  completed: 'neutral',
  ended: 'neutral',
  expired: 'neutral',
  rejected: 'danger',
  cancelled: 'danger',
  failed: 'danger'
}

export default function CampaignStatusTag({ status, variant = 'soft' }) {
  const key = (status ?? '').toLowerCase()
  const toneKey = STATUS_TONE[key] || 'neutral'
  const label = status ? `${status.charAt(0).toUpperCase()}${status.slice(1)}` : '--'

  if (variant === 'solid') {
    const Icon = SOLID_ICONS[toneKey]
    return (
      <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${SOLID_TONES[toneKey]}`}>
        <Icon size={13} /> {label.toUpperCase()}
      </span>
    )
  }

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${TONES[toneKey]}`}>
      {label}
    </span>
  )
}
